export const educations = [
    {
        "studyType": "MCA",
        "endDate": "2016",
        "institution": "Sri Venkateswara College of Engineering",
        "location": "Sriperumbudur",
        "area": "Computer Science",
        "gpa": "8.09",
        "startDate": "2013"
    },
    {
        "institution": "VHNSN, Madurai Kamaraj University",
        "location": "Virudhunagar",
        "studyType": "BCA",
        "area": "Computer Science",
        "gpa": "6.73",
        "startDate": "2010",
        "endDate": "2013"
    }
]